export default (toolName : string, toolId : string) => {
  window.TRACKING_TOOLS.set(toolName, {
    required_cookie_settings: '',
    initTracking () {
      window._paq = window._paq || []
      /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
      window._paq.push(['trackPageView'])
      window._paq.push(['enableLinkTracking'])
      const u = 'https://matomo.dekra.bawue.com/'
      window._paq.push(['setTrackerUrl', `${u}matomo.php`])
      window._paq.push(['setSiteId', toolId])
      const d = document
      const g = d.createElement('script')
      const s = d.getElementsByTagName('script')[0]
      g.type = 'text/javascript'
      g.async = true
      g.defer = true
      g.src = `${u}matomo.js`
      s.parentNode?.insertBefore(g, s)
    },
  })
}
